(function ($) {


    this.init = function () {
        this.LocationsSearch();
    };


    /****************************************************************
     HOMEPAGE BANNER
    ****************************************************************/
    this.LocationsSearch = function () {

        $(".locationsModule .cooprow .form-check-input").on("change", function () {
            // when you check or uncheck one of these boxes, you should automatically click the seach button to resubmit
            $("#submitSearch").click();
        });

    }

    this.init();

})(jQuery);